import { useState } from 'react'
import DataTable from './DataTable'
import { KTSVG } from '../../_metronic/helpers'
import Swal from 'sweetalert2'
import ItemCategoryCreate from './ItemCategoryCreate';
import 'react-loading-skeleton/dist/skeleton.css';

function ItemCategoryList() {

    const hasPermission = 1//parseInt(GetPagePermission("/setup-company-list"));
    const [newData, setNewData] = useState({});
    const [id, setId] = useState(0);

    const [createItemCategoryModalShow, setCreateItemCategoryModalShow] = useState(false);

    const handleCreateItemCategoryModalShow = () => {
        setId(0)
        setCreateItemCategoryModalShow(true);
    }

    const handleCreateItemCategoryModalClose = (isReload: boolean) => {
        setCreateItemCategoryModalShow(false);
        if (isReload) {
            setNewData({ id: Date.now() });
        }
    }

    const editItemCategory = (id: number): void => {
        setId(id);
        setCreateItemCategoryModalShow(true);
    };

    const deleteItemCategory = (id: number): void => {
        if (window.confirm("Are you sure you want to delete this item category?")) {
            const myToken: string | null = localStorage.getItem('MyToken');
            let jwt: string | null = (myToken != null) ? JSON.parse(myToken) : null;
            fetch(`${process.env.REACT_APP_API_URL}itemCategories/${id}`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${jwt}` }
            })
                .then((resp: Response) => {
                    return resp.json();
                })
                .then((resp: any) => {
                    if (resp.success) {
                        const successMsg: string = resp.successMessage;
                        Swal.fire({
                            icon: 'success',
                            title: 'Deleted!',
                            text: successMsg,
                        });
                        setNewData({ id: Date.now() });
                    }
                })
                .catch((error: any) => {
                    console.log(error, 'catch the hoop');
                });
        }
    };

    const columns = [
        { value: 'id', title: 'Id', style: { textAlign: 'center' } },
        { value: 'categoryName', title: 'Category', style: { textAlign: 'left' } },
        { value: 'categoryPrefix', title: 'Prefix', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'left', whiteSpace: 'nowrap' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return (
                    <>
                        <button className="btn btn-light-danger btn-sm p-2" onClick={() => editItemCategory(row.idItemCategories)}>
                            <button className="btn btn-light-primary btn-sm">
                                <KTSVG
                                    path='/media/svg/icons/Communication/Write.svg'
                                    className='svg-icon-5 svg-icon'
                                />		Edit
                            </button>
                        </button>
                        <button className="btn btn-light-danger btn-sm p-2" onClick={() => deleteItemCategory(row.idItemCategories)}>
                            <KTSVG
                                path='/media/svg/icons/General/Trash.svg'
                                className='svg-icon-5 svg-icon'
                            />		Delete
                        </button>
                    </>
                )
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        categoryName: {
            filterType: 'like',
            filterValue: '',
        },
        categoryPrefix: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'itemCategories'

    return (
        <>
            {hasPermission === 1 &&
                <div className='card card-custom'>
                    <div className='card-header'>
                        <div className="card-title">
                            <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                            <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                Item Category List
                            </span>
                        </div>
                        <div className="card-toolbar">
                            <div className='d-flex justify-content-end'>
                                <button type="button" className="btn btn-sm btn-primary" onClick={() => handleCreateItemCategoryModalShow()}><i className="fa fa-plus"></i>Add Item Category</button>
                            </div>
                        </div>
                    </div>

                    <div className='card-body'>
                        <DataTable url={url} columns={columns} filters={filters} newData={newData} />
                    </div>
                </div>
            }

            <ItemCategoryCreate show={createItemCategoryModalShow} handleClose={handleCreateItemCategoryModalClose} id={id} />



        </>
    )
}

export default ItemCategoryList
